import { Checkbox } from '@mui/material';
import { ReactComponent as CheckboxIcon } from '../../assets/Checkbox.svg';
import { ReactComponent as CheckboxOutlineIcon } from '../../assets/CheckboxOutline.svg';

type AzulCheckboxProps = { checked: boolean; onClick?: () => void };

const AzulCheckbox = ({ checked, onClick }: AzulCheckboxProps) => (
  <Checkbox
    checked={checked}
    checkedIcon={<CheckboxIcon />}
    disableRipple
    icon={<CheckboxOutlineIcon />}
    sx={{ padding: 0 }}
    onClick={onClick}
  />
);

export default AzulCheckbox;
